import {
  StaffBranchResponse,
  StaffCompanyReferenceResponse,
  StaffCostCenterResponse,
  StaffDepartmentResponse,
  StaffPositionResponse,
} from "lib-klab-sdks";
import {
  OrganizationBranch,
  OrganizationCompany,
  OrganizationCostCenter,
  OrganizationDepartment,
  OrganizationPosition,
} from "../../../domain/models/organization/organization-reference.model";

export const mapOrganizationCompany = (
  source: StaffCompanyReferenceResponse,
): OrganizationCompany => ({
  id: source.id,
  name: source.name,
  state: source.state,
});

export const mapOrganizationBranch = (
  source: StaffBranchResponse,
): OrganizationBranch => ({
  id: source.branchId,
  companyId: source.companyId,
  name: source.name,
  address: source.address,
  phone: source.phone,
  status: source.status,
});

export const mapOrganizationDepartment = (
  source: StaffDepartmentResponse,
): OrganizationDepartment => ({
  id: source.id,
  name: source.name,
});

export const mapOrganizationPosition = (
  source: StaffPositionResponse,
): OrganizationPosition => ({
  id: source.id,
  departmentId: source.departmentId,
  name: source.name,
  active: source.active,
});

export const mapOrganizationCostCenter = (
  source: StaffCostCenterResponse,
): OrganizationCostCenter => ({
  id: source.costCenterId,
  companyId: source.companyId,
  code: source.code,
  name: source.name,
});
